// extracted by mini-css-extract-plugin
export default {"qrWriter":"QrWriterPage_qrWriter__U+yX+","qrWriterHeader":"QrWriterPage_qrWriterHeader__IawB0"};